/**
 * Shown when the build has no Supabase connection.
 *
 * The alternative — rendering the shell with every panel empty — would look exactly like a working ERP
 * with no data in it. That is the most misleading screen this application could possibly show, so it says
 * what is actually wrong instead.
 */
import { Panel, PanelHeader, SectionLabel } from '../ui/primitives';

export function NotConfigured() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper p-6">
      <Panel className="w-full max-w-lg">
        <PanelHeader title="No database connection" />
        <div className="space-y-4 px-4 py-4">
          <p className="text-body">
            This build has no Supabase URL or key, so it cannot show any data. It is not showing you an
            empty ERP — it is not connected to one.
          </p>
          <div>
            <SectionLabel>To connect it</SectionLabel>
            <pre className="mt-2 overflow-x-auto rounded-[var(--radius-control)] border border-line bg-surface-sunken p-3 code-text">
{`cd apps/erp
cp .env.example .env.local

# then paste the values printed by:
pnpm db:start`}
            </pre>
          </div>
          <p className="text-small text-ink-muted">
            Only the anon key belongs here. It is public by design: every rule is enforced by row level
            security and by the api.* command functions, never by this application.
          </p>
        </div>
      </Panel>
    </div>
  );
}
